import { dispatch, State, useSelector } from '@ui-complex/react-state';

export const crmGlobalState = {
  mapConfig: {
    visible: false
  },
  setting: {
    visible: false
  },
  employeeStatsModal: false,
  tableSetting: {
    visible: false
  }
};

export const useCrmState = <T, _>(myFunction: (state: typeof crmGlobalState) => T) =>
  useSelector(crmGlobalState, myFunction);

export const crmDispatch = <T, _>(myFunction: (state: typeof crmGlobalState) => T) =>
  dispatch(crmGlobalState, myFunction);

export const StateCrm = <T, _>({
  children,
  selector
}: {
  children: (props: T) => React.ReactElement;
  selector: (state: typeof crmGlobalState) => T;
}) => <State state={crmGlobalState} selector={selector} children={children} />;
